var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dropdown",
        { attrs: { trigger: "click" } },
        [
          _c("input", {
            ref: "trackButton",
            attrs: { id: "input", type: "button", hidden: "" },
          }),
          _c(
            "el-dropdown-menu",
            { staticClass: "track-menu", attrs: { "append-to-body": false } },
            _vm._l(_vm.trackMenu, function (item, key) {
              return _c(
                "el-dropdown-item",
                {
                  key: key,
                  nativeOn: {
                    click: function ($event) {
                      return _vm.trackMenuClick(item)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "menu-item" }, [
                    _vm._v(_vm._s(_vm.i18n_map[item])),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }